import { Component, OnInit,ViewChild,ElementRef,HostListener } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import {UtilsService} from '../common/services/utils.service';
import { FormGroup,FormControl,FormArray} from '@angular/forms';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;
declare var cars_list_price_from_to: Function;
declare var cars_list_km_driven_from_to: Function;
declare var cars_list_year_from_to: Function;
declare var manage_show_hide_inspection_detail: Function;

@Component({
  selector: 'app-fixed-price-cars',
  templateUrl: './fixed-price-cars.component.html',
  styleUrls: ['./fixed-price-cars.component.css']
})
export class FixedPriceCarsComponent implements OnInit {

  carListFixedPrice=[]; 
  fileUrl;
  brandList;
  sessionId;
  actionStatus:boolean=false;
  sessionProfileType:number=-1;
  ModelList=[{"id":"","name":"Choose make first"}];
  brandModelList=[];
  brandWithCountList=[];
  fuelTypetList=[];
  bodyTypetList=[];

  brandFormGroup;
  fuelTypetFormGroup;
  noOfOwnerGroup;
  transmissionTypeGroup;
  bodyTypetFormGroup;
  sessionStatus:number=-1;
  carListCount:number=0;
  getListRequestInprocess:boolean=false;
  currentListCount:number=0;
  fetch:boolean=false;

  private itemContainer: any;
  private scrollContainer: any;
  private isNearBottom = true;

  @ViewChild('searchChooseMake') searchChooseMake: ElementRef;
  @ViewChild('searchModel') searchModel: ElementRef;
  @ViewChild('searchYearFromTo') searchYearFromTo: ElementRef;  
  @ViewChild('sortByPrice') sortByPrice: ElementRef;
  @ViewChild('sortByLatest') sortByLatest: ElementRef;
  @ViewChild('priceFrom') priceFrom: ElementRef;
  @ViewChild('priceTo') priceTo: ElementRef;
  @ViewChild('kmDrivenFrom') kmDrivenFrom: ElementRef;
  @ViewChild('kmDrivenTo') kmDrivenTo: ElementRef;
  @ViewChild('yearFrom') yearFrom: ElementRef;
  @ViewChild('yearTo') yearTo: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private httpserviceService:HttpserviceService,
    private sessionsService:SessionsService,
    private router:Router,
    private _constant: ConstantsService,
    private utilsService:UtilsService
    ) { }
    

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
        
    window.scrollTo(0, 0);
    this.sessionId=this.sessionsService.getSession("id");
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("status")!=null)
    {
       this.sessionStatus=this.sessionsService.getSession("status");
    }

    this.brandFormGroup=new FormGroup(
       {
         brand:  new FormArray([])
       });

    this.fuelTypetFormGroup=new FormGroup(
       {
         fuelType:  new FormArray([])
       });

    this.noOfOwnerGroup=new FormGroup(
       {
         noOfOwner1:  new FormControl(false),
         noOfOwner2:  new FormControl(false),
         noOfOwner3:  new FormControl(false),
         noOfOwner4:  new FormControl(false)
       });
       
    this.transmissionTypeGroup=new FormGroup(
       {
         transmissionType1:  new FormControl(false),
         transmissionType2:  new FormControl(false),
         transmissionType3:  new FormControl(false)
       }); 

    this.bodyTypetFormGroup=new FormGroup(
       {
         bodyType:  new FormArray([])
       });   

    //this.fileUrl=this._constant.uploadFileUrl 
    //aws server url for upload and get changes
    this.fileUrl=this._constant.uploadFileUrlForAWS;
    
    this.brandList=this.sessionsService.getSession("brand_list");
    this.getBrandWithCount();
    this.getFuelTypeList();
    this.getCarBodyType();
    cars_list_price_from_to();
    cars_list_km_driven_from_to();
    cars_list_year_from_to();

    if(this.utilsService.homeSearch!="")
     {
     setTimeout(() => {  
    console.log(this.utilsService.homeSearch);
    this.brandModelList=this.utilsService.homeSearch.brand_model_list;
    this.ModelList=this.brandModelList[this.utilsService.homeSearch.brand];
    this.searchChooseMake.nativeElement.value=this.utilsService.homeSearch.brand;  
    //alert(this.utilsService.homeSearch.model);
    //this.searchModel.nativeElement.value=this.utilsService.homeSearch.model;
    //alert(this.searchModel.nativeElement.value);
    this.searchYearFromTo.nativeElement.innerHTML=this.utilsService.homeSearch.year_from_to;  
    //this.utilsService.homeSearch="";
    }, 200);
    setTimeout(() => {     
    this.searchModel.nativeElement.value=this.utilsService.homeSearch.model;
    this.utilsService.homeSearch="";
    this.getCarList(1);//type 1 fixed price and 2 auctio
    }, 500);  
     }
     else
     {
    this.getBrandModelList();    
    setTimeout(() => {
    this.getCarList(1);//type 1 fixed price and 2 auction  
    }, 200);
     }

     setTimeout(() => {
      manage_show_hide_inspection_detail(); 
     }, 300);
  }

  /** getCarList function used to get car list  */
  getCarList(type)//type 1 fixed price and 2 auction
  {
    this.carListFixedPrice=[];
    this.carListCount=0;  
    this.currentListCount=0;
    let from_to="";
    if(this.searchYearFromTo.nativeElement.innerHTML.indexOf("Year Range")<0)
    {
      from_to=this.searchYearFromTo.nativeElement.innerHTML;
    }

    let sortBy={"sort_by":""};
    if(this.sortByPrice.nativeElement.checked)
    {
      sortBy["sort_by"]="price";
    }
    if(this.sortByLatest.nativeElement.checked)
    {
      sortBy["sort_by"]="desc";
    } 

    let filterBy={};

    filterBy["search_input"]=this.searchInput.nativeElement.value;

    const selectedBrandIds = this.brandFormGroup.value.brand
     .map((v, i) => v ? this.brandWithCountList[i].id : null)
     .filter(v => v !== null);
     filterBy["band"]=selectedBrandIds.join("^");

     const selectedFuelTypeIds = this.fuelTypetFormGroup.value.fuelType
     .map((v, i) => v ? this.fuelTypetList[i].id : null)
     .filter(v => v !== null);
     filterBy["fuel_type"]=selectedFuelTypeIds.join("^");

     filterBy["price_from"]=this.priceFrom.nativeElement.value;
     filterBy["price_to"]=this.priceTo.nativeElement.value;
     filterBy["km_driven_from"]=this.kmDrivenFrom.nativeElement.value;
     filterBy["km_driven_to"]=this.kmDrivenTo.nativeElement.value;
     filterBy["year_from"]=this.yearFrom.nativeElement.value;
     filterBy["year_to"]=this.yearTo.nativeElement.value;

     let noOfOwner="";
     if(this.noOfOwnerGroup.controls['noOfOwner1'].value)
     {
      noOfOwner=noOfOwner+"1^";
     }
     if(this.noOfOwnerGroup.controls['noOfOwner2'].value)
     {
      noOfOwner=noOfOwner+"2^";
     }
     if(this.noOfOwnerGroup.controls['noOfOwner3'].value)
     {
      noOfOwner=noOfOwner+"3^";
     }
     if(this.noOfOwnerGroup.controls['noOfOwner4'].value)
     {
      noOfOwner=noOfOwner+"4^";
     }
     filterBy["no_of_owner"]=noOfOwner;

     let transmissionType="";
     if(this.transmissionTypeGroup.controls['transmissionType1'].value)
     {
      transmissionType=transmissionType+"1^";
     }
     if(this.transmissionTypeGroup.controls['transmissionType2'].value)
     {
      transmissionType=transmissionType+"2^";
     }
     if(this.transmissionTypeGroup.controls['transmissionType3'].value)
     {
      transmissionType=transmissionType+"3^";
     }
     filterBy["transmission"]=transmissionType;

     const selectedBodyTypeIds = this.bodyTypetFormGroup.value.bodyType
     .map((v, i) => v ? this.bodyTypetList[i].id : null)
     .filter(v => v !== null);
     filterBy["body_type"]=selectedBodyTypeIds.join("^");

    this.getListRequestInprocess=true;
    let searchBy ={"brand":this.searchChooseMake.nativeElement.value,"model":this.searchModel.nativeElement.value,"from_to":from_to}
    let result =this.httpserviceService.carListRequest(this.sessionsService.getSession("id"),type,(this.currentListCount)+"",filterBy,sortBy,searchBy).
     pipe(retry(0)).
     subscribe((data)=>this.carListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })

    let result2 =this.httpserviceService.carListCountRequest(this.sessionsService.getSession("id"),type,"0",filterBy,sortBy,searchBy).
     pipe(retry(0)).
     subscribe((data)=>this.carListCountResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** carListResponse function used to handle response */
  carListResponse(response)
  {
    this.getListRequestInprocess=false;
    console.log('carListResponse '+ response);
    if(response.status==="success")  
     {   
       let list=response.list;  
       list.forEach((element) => { 
        //console.log("carListAuction "+this.carListAuction);
         console.log("value "+element);   
       this.carListFixedPrice.push(element); 
       });         
       this.currentListCount=this.carListFixedPrice.length;   
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** carDetail function used to get car detail */
  carDetail(id)
  {
    this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: id } });
  }

  /** getModelFromId function used to get model from id  */
   getModelFromId(id)
   {
     if(this.sessionsService.getSession('all_model_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_model_list');     
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getVariantFromId function used to get variant from id  */
   getVariantFromId(id)
   {     
     if(this.sessionsService.getSession('all_variant_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_variant_list');         
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getBrandModelList function used to get brand model list */ 
  getBrandModelList()
  { 
    let result =this.httpserviceService.getBrandModelListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getBrandModelListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandModelListResponse function used to handle response */
  getBrandModelListResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.brandModelList=response.list;     
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

   /** getModelListFromId function used to get model from id  */
   getModelListFromId(id)
   { 
     if(this.brandModelList!=null && id>0)
     {       
     this.ModelList=this.brandModelList[id];    
     }
   }

   /** getBrandWithCount function used to get brand with count list */ 
  getBrandWithCount()
  { 
    let result =this.httpserviceService.getBrandWithCountRequest(1).
     pipe(retry(0)).
     subscribe((data)=>this.getBrandWithCountResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandWithCountResponse function used to handle response */
  getBrandWithCountResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.brandWithCountList=response.list;   
       this.brandWithCountList.forEach((o, i) => {
      const control = new FormControl(false); // if first item set to true, else false
      (this.brandFormGroup.controls.brand as FormArray).push(control);
      });  
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getFuelTypeList function used to get fuel type list */ 
  getFuelTypeList()
  { 
    let result =this.httpserviceService.getFuelTypeListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getFuelTypeListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandWithCountResponse function used to handle response */
  getFuelTypeListResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.fuelTypetList=response.list1;   
       this.fuelTypetList.forEach((o, i) => {
      const control = new FormControl(false); // if first item set to true, else false
      (this.fuelTypetFormGroup.controls.fuelType as FormArray).push(control);
      });  
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getCarBodyType function used to get car body type list */ 
  getCarBodyType()
  { 
    let result =this.httpserviceService.getCarBodyTypeRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getCarBodyTypeResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getCarBodyTypeResponse function used to handle response */
  getCarBodyTypeResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.bodyTypetList=response.list;   
       this.bodyTypetList.forEach((o, i) => {
      const control = new FormControl(false); 
      (this.bodyTypetFormGroup.controls.bodyType as FormArray).push(control);
      });  
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** proceedAddCarInFavorite function used to add car in favorite list */ 
  proceedAddCarInFavorite(carId)
  { 
    show_okshan_alert("Adding in favorite");
    let result =this.httpserviceService.addCarInFavoriteRequest(carId).
     pipe(retry(0)).
     subscribe((data)=>this.addCarInFavoriteResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getCarBodyTypeResponse function used to handle response */
  addCarInFavoriteResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
      show_okshan_alert("Added in favorite");   
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** show alert msg */
   /** show alert msg */
   show_msg(msg)
   {
     if(msg=="profile completion")
     {
       if(this.sessionProfileType==-1)
       {
         show_okshan_alert("Complete registration for more detail");
       }
       else if(this.sessionStatus!=1)
       {
         show_okshan_alert("Your profile is under approval");
       }
       else if(this.sessionProfileType==1)
       {
         show_okshan_alert("This feature is not authorized for you");
       }
     }
    else
    { 
    show_okshan_alert(msg);
    }
   }

   /** carListResponse function used to handle response */
  carListCountResponse(response)
  {
    console.log('carListResponse '+ response);
    if(response.status==="success")  
     {       
       this.carListCount=response.count;  
       this.fetch=true;             
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  private scrollToBottom(): void {
    window.scroll({
      top: this.scrollContainer.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

  private isUserNearBottom(): boolean {
    const threshold = 300;
    const position = window.scrollY + window.innerHeight;
    const height = document.body.scrollHeight;
    return position > height - threshold;
  }

  @HostListener('window:scroll', ['$event'])
  scrolled(event: any): void {
    this.isNearBottom = this.isUserNearBottom();
    if(this.isNearBottom)
    {
     if(!this.getListRequestInprocess)
     { 
     if(this.carListFixedPrice.length<this.carListCount)
     {  
     this.getMoreCarList(1);
     }
     }
    }
  }

  /** getCarList function used to get car list  */
  getMoreCarList(type)//type 1 fixed price and 2 auction
  {
    let from_to="";
    if(this.searchYearFromTo.nativeElement.innerHTML.indexOf("Year Range")<0)
    {
      from_to=this.searchYearFromTo.nativeElement.innerHTML;
    }

    let sortBy={"sort_by":""};
    if(this.sortByPrice.nativeElement.checked)
    {
      sortBy["sort_by"]="price";
    }
    if(this.sortByLatest.nativeElement.checked)
    {
      sortBy["sort_by"]="desc";
    } 

    let filterBy={};

    filterBy["search_input"]=this.searchInput.nativeElement.value;

    const selectedBrandIds = this.brandFormGroup.value.brand
     .map((v, i) => v ? this.brandWithCountList[i].id : null)
     .filter(v => v !== null);
     filterBy["band"]=selectedBrandIds.join("^");

     const selectedFuelTypeIds = this.fuelTypetFormGroup.value.fuelType
     .map((v, i) => v ? this.fuelTypetList[i].id : null)
     .filter(v => v !== null);
     filterBy["fuel_type"]=selectedFuelTypeIds.join("^");

     filterBy["price_from"]=this.priceFrom.nativeElement.value;
     filterBy["price_to"]=this.priceTo.nativeElement.value;
     filterBy["km_driven_from"]=this.kmDrivenFrom.nativeElement.value;
     filterBy["km_driven_to"]=this.kmDrivenTo.nativeElement.value;
     filterBy["year_from"]=this.yearFrom.nativeElement.value;
     filterBy["year_to"]=this.yearTo.nativeElement.value;

     let noOfOwner="";
     if(this.noOfOwnerGroup.controls['noOfOwner1'].value)
     {
      noOfOwner=noOfOwner+"1^";
     }
     if(this.noOfOwnerGroup.controls['noOfOwner2'].value)
     {
      noOfOwner=noOfOwner+"2^";
     }
     if(this.noOfOwnerGroup.controls['noOfOwner3'].value)
     {
      noOfOwner=noOfOwner+"3^";
     }
     filterBy["no_of_owner"]=noOfOwner;

     let transmissionType="";
     if(this.transmissionTypeGroup.controls['transmissionType1'].value)
     {
      transmissionType=transmissionType+"1^";
     }
     if(this.transmissionTypeGroup.controls['transmissionType2'].value)
     {
      transmissionType=transmissionType+"2^";
     }
     if(this.transmissionTypeGroup.controls['transmissionType3'].value)
     {
      transmissionType=transmissionType+"3^";
     }
     filterBy["transmission"]=transmissionType;

     const selectedBodyTypeIds = this.bodyTypetFormGroup.value.bodyType
     .map((v, i) => v ? this.bodyTypetList[i].id : null)
     .filter(v => v !== null);
     filterBy["body_type"]=selectedBodyTypeIds.join("^");

    this.getListRequestInprocess=true;
    let searchBy ={"brand":this.searchChooseMake.nativeElement.value,"model":this.searchModel.nativeElement.value,"from_to":from_to}
    let result =this.httpserviceService.carListRequest(this.sessionsService.getSession("id"),type,(this.currentListCount)+"",filterBy,sortBy,searchBy).
     pipe(retry(0)).
     subscribe((data)=>this.carListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** clearFilter function used to clear filter */
  clearFilter()
  {
    window.location.reload();
  }

  /** fixedPriceCars function used to get fixed price cars */
  fixedPriceCars()
  {
     this.router.navigate(['fixed-price-cars']);
  }

  /** auctionCars function used to get auction cars */
  auctionCars()
  {
     this.router.navigate(['auction-cars']);
  }

}
